import React from "react";
import { FiEdit3, FiPlus } from "react-icons/fi";
import ScreenHeader from "./ScreenHeader";
import ScreenMetric from "./ScreenMetric";

const ExpensesScreen = ({ expenses, onAction }) => {
  const rows = Array.isArray(expenses) ? expenses : [];
  const pendingCount = rows.filter((row) => ["Pending", "Submitted", "Review", "In Review", "Need More Information"].includes(row.status)).length;
  const draftCount = rows.filter((row) => row.status === "Draft").length;

  return (
    <section className="new-hrm-screen">
      <ScreenHeader
        eyebrow="Finance"
        title="Expenses"
        description="Create claims, monitor reimbursements, and keep drafts organized."
        actions={(
          <button className="new-hrm-primary-button" type="button" onClick={() => onAction("expense")}>
            <FiPlus aria-hidden="true" />
            <span>Add Expense</span>
          </button>
        )}
      />
      <div className="new-hrm-screen-metrics">
        <ScreenMetric label="This month" value={rows.length} detail="Visible claims" />
        <ScreenMetric label="Pending" value={pendingCount} detail="Awaiting review" />
        <ScreenMetric label="Drafts" value={draftCount} detail="Not submitted" />
      </div>
      <section className="new-hrm-panel">
        <h2>Expense Claims</h2>
        <div className="new-hrm-data-table new-hrm-data-table--expenses">
          <div className="new-hrm-data-table__head">
            <span>Expense</span>
            <span>Category</span>
            <span>Amount</span>
            <span>Date</span>
            <span>Bill</span>
            <span>Status</span>
            <span className="new-hrm-data-table__action-heading">Action</span>
          </div>
          {rows.map((expense) => {
            const isRejected = String(expense.status || "").toLowerCase().includes("reject");
            return (
            <button
              key={expense.id}
              type="button"
              className="new-hrm-data-row"
              onClick={() => onAction("expense", expense)}
              aria-label={`${expense.canEdit ? "Edit" : "View"} expense claim ${expense.title}`}
            >
              <span className="new-hrm-expense-row__summary">
                <strong>{expense.title}</strong>
                {expense.description && <small>{expense.description}</small>}
              </span>
              <span>{expense.category}</span>
              <strong>{expense.amount}</strong>
              <span>{expense.date}</span>
              <span>{expense.attachmentCount ? `${expense.attachmentCount} attached` : "Not attached"}</span>
              <span className="new-hrm-expense-row__status">
                <em className={`new-hrm-status new-hrm-status--${expense.status === "Approved" ? "approved" : isRejected ? "rejected" : "pending"}`}>
                  {expense.status}
                </em>
                {isRejected && expense.rejectionReason && <small>Reason: {expense.rejectionReason}</small>}
              </span>
              <span className="new-hrm-expense-row__action">
                {expense.canEdit ? (
                  <span className="new-hrm-edit-cue" aria-hidden="true" title="Editable claim">
                    <FiEdit3 />
                    <span>Edit</span>
                  </span>
                ) : null}
              </span>
            </button>
            );
          })}
          {!rows.length && (
            <p className="new-hrm-empty-state">No expenses found.</p>
          )}
        </div>
      </section>
    </section>
  );
};

export default ExpensesScreen;
